import { applicationLiabilityApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LIABILITIES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/liabilities`,
  {
    GET_LIABILITIES: 'GET_LIABILITIES',
    DELETE_LIABILITY: 'DELETE_LIABILITY',
  },
);

export const deleteLoanLiabilityAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationLiabilityApi.deleteLiability(params);

  return dispatch({
    type: LIABILITIES_ACTION_TYPE.DELETE_LIABILITY,
    meta: params,
    payload: data,
  });
});
